import { render } from "./triggers-list.vue?vue&type=template&id=5c68f745&scoped=true"
import script from "./triggers-list.vue?vue&type=script&lang=js"
export * from "./triggers-list.vue?vue&type=script&lang=js"

import "./triggers-list.vue?vue&type=style&index=0&id=5c68f745&scoped=true&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c68f745"]])

export default __exports__